// eslint-disable-next-line import/no-unresolved
import { Content } from '@plone/types';
import { toPublicURL } from '@plone/volto/helpers/Url/Url';
import { OccasionProps } from '@fhnw/types/occasion';
import { BaseSchema, Schema } from './types';
import { generateSchema } from './SchemaGeneration';

export const SCHEMA_CONTEXT = 'https://schema.org';

/**
 * Combine several schemas into one single root node.
 *
 * Safari throws `TypeError: undefined is not an object (evaluating
 * 'r["@context"].toLowerCase')` whenever the root of an `application/ld+json`
 * script is an array, even though that is valid JSON-LD
 * (https://bugs.webkit.org/show_bug.cgi?id=255764). Wrapping the schemas in
 * `@graph` keeps the same semantics with an object as root node.
 */
export const toSingleRootNode = (schemas: Schema[]): Schema => {
  const nodes = schemas.map(({ '@context': _context, ...node }) => node);

  if (nodes.length === 1) {
    return { '@context': SCHEMA_CONTEXT, ...nodes[0] };
  }

  return { '@context': SCHEMA_CONTEXT, '@graph': nodes as BaseSchema[] };
};

export const generateKnowsAbout = (items: Content[]): BaseSchema[] => {
  if (!items || items.length === 0) {
    return [];
  }

  return items.map((item) => ({
    '@type': 'DefinedTerm',
    name: item.title,
    description: item.description,
    url: toPublicURL(item['@id']),
    identifier: toPublicURL(item['@id']),
  }));
};

export const generateExecutions = (
  occasions: OccasionProps[],
  parent: Content,
  type: string,
  state: any,
): BaseSchema[] => {
  return occasions.map((occasion) => {
    return {
      ...generateSchema({
        type: 'Occasion',
        content: {
          '@type': 'Occasion',
          parent: parent,
          ...occasion,
        } as unknown as Content,
        state: state,
        partial: true,
      }),
      '@type': type,
    };
  }) as BaseSchema[];
};
